// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/chat-close.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat {
  border-radius: 15px;
  padding: 0.375rem;
  background: #1DADB5;
  width: 100%;
  font-size: 0.75rem;
  font-weight: 500;
  position: relative;
  flex-grow: 1;
}
.chat .drop-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.chat .drop-overlay i {
  font-size: 2rem;
  color: #FFF;
}
.chat .chat_exit_button {
  height: 30px;
  width: 30px;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  right: 0px;
  top: -22px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}
.chat .chat_messages {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1 1;
  overflow-y: hidden;
  background: #FDFBFB;
  border-radius: 15px;
  height: 200px;
  max-height: calc(50vh - 225px);
}
@media (max-width: 991px), (max-height: 699px) {
  .chat .chat_messages {
    max-height: calc(50vh - 175px);
  }
}
.chat .chat_messages ul {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.chat .chat_messages ul .message {
  clear: both;
  width: 100%;
  margin-right: auto;
  margin-left: 0px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding: 0.25rem 0.25rem;
}
.chat .chat_messages ul .message.my-message {
  margin-right: 0px;
  margin-left: auto;
  justify-content: flex-end;
}
.chat .chat_messages ul .message .message-content {
  color: #00666F;
  background: #EEE7E1;
  border-radius: 10px;
  width: 100%;
  padding: 0.375rem;
  overflow: hidden;
}
.chat .chat_messages ul .message .message-content p {
  margin: 0;
  word-wrap: break-word;
}
.chat .chat_messages ul .message .message-content.message-media {
  border-radius: 20px;
  border: 1px solid #697F8C;
  width: 70px;
  height: 70px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.chat .chat_messages ul .message .message-content.message-media img {
  padding: 5px;
  max-width: 100%;
}
.chat .chat_messages ul .message .message-content.message-media i {
  font-size: 40px;
}
.chat .chat_message_action {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin-top: 0.375rem;
  align-items: center;
  position: relative;
}
.chat .chat_message_action .chat_message_write {
  width: 100%;
  width: calc(100% - 2.25rem);
  margin-left: auto;
  margin-right: 0;
  position: relative;
  border-radius: 0.875rem;
  flex-grow: 1;
  display: flex;
  height: 2.5rem;
  overflow: hidden;
  background: #FDFBFB;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  box-shadow: inset -2px 2px 2px rgba(0, 0, 0, 0.25);
}
.chat .chat_message_action .chat_message_write .chat_message_form_input {
  background: #FDFBFB;
  flex: 1 1 auto;
  border: none;
  outline: none;
  resize: none;
  border-radius: 0px;
  height: 100%;
  padding: 0.75rem 0.25rem 0.75rem 0.25rem;
  color: #00666F;
  box-shadow: inset 2px 2px 2px rgba(0, 0, 0, 0.25);
  border: none;
}
.chat .chat_message_action .chat_message_write .chat_message_form_input:focus {
  outline: none;
  border: none;
  box-shadow: inset 2px 2px 4px rgba(29, 173, 181, 0.5);
}
.chat .chat_message_action .chat_message_write .chat_message_send {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  width: 1.875rem;
  height: 1.875rem;
  font-size: 1.125rem;
  padding: 0px;
  border-radius: 50%;
  flex: 0 0 1.875rem;
}
.chat .chat_message_action .chat_message_write .chat_message_send .icon-plane {
  margin-left: 2px;
}
.chat .chat_message_action .btn-upload {
  width: 100%;
}
.chat .chat_message_action .btn-upload .progress {
  margin-bottom: 0.375rem;
}
.chat .chat_message_action .btn-upload .btn {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  font-size: 1.125rem;
  padding: 0px;
  border-radius: 50%;
  position: absolute;
  bottom: 0.25rem;
  left: 0px;
  z-index: 1;
}
@media (max-width: 991px), (max-height: 699px) {
  .chat {
    font-size: 0.625rem;
  }
  .chat .chat_messages ul {
    list-style: none;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .chat .chat_messages ul .message .message-content {
    padding: 0.375rem;
  }
  .chat .chat_messages ul .message .message-content.message-media {
    padding: 0.125rem;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.5rem;
  }
  .chat .chat_messages ul .message .message-content.message-media i {
    font-size: 1.75rem;
  }
}
@media (max-width: 575px), (max-height: 576px -1) {
  .chat {
    position: fixed;
    top: 50px;
    bottom: 70px;
    left: 5%;
    right: 5%;
    display: flex;
    flex-direction: column;
    width: auto;
  }
  .chat .chat_messages {
    flex: 1 1 auto;
    max-height: none;
    height: auto;
  }
}
@media (max-width: 575px) {
  .chat {
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    border-radius: 0px;
    max-height: 25%;
  }
}

#btn-show-messages {
  text-align: center;
  position: absolute;
  bottom: 10px;
  width: 100%;
  border: 0;
  z-index: 2;
  cursor: pointer;
}
#btn-show-messages .btn {
  padding: 5px 15px 5px;
  border-radius: 20px;
  font-size: 12px;
}
#btn-show-messages.hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/Chat.scss","webpack://./src/styles/abstracts/_variables.scss","webpack://./src/styles/abstracts/_functions.scss"],"names":[],"mappings":"AAGA;EACI,mBC6Cc;ED5Cd,iBAAA;EACA,mBCWa;EDVb,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAFJ;AAGI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AADR;AAEQ;EACI,eAAA;EACA,WAAA;AAAZ;AAGI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,2EAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EAGA,mBCtCO;EDuCP,mBCCU;EDAV,aAAA;EACA,8BAAA;AAJR;AEiCE;EFxCE;IAaQ,8BAAA;EAFV;AACF;AAGQ;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AADZ;AAGY;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,wBAAA;AADhB;AAGgB;EACI,iBAAA;EACA,iBAAA;EACA,yBAAA;AADpB;AAIgB;EACI,cC9DE;ED+DF,mBCrEP;EDsEO,mBCnCF;EDoCE,WAAA;EACA,iBAAA;EACA,gBAAA;AAFpB;AAGoB;EACI,SAAA;EACA,qBAAA;AADxB;AAIoB;EACI,mBC3CN;ED4CM,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAFxB;AAIwB;EACI,YCpDpB;EDqDoB,eAAA;AAF5B;AAKwB;EACI,eAAA;AAH5B;AAWI;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AATR;AAWQ;EACI,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBC/HG;EDgIH,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kDAAA;AATZ;AAWY;EACI,mBCtID;EDuIC,cAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,cCpIM;EDqIN,iDAAA;EACA,YAAA;AAThB;AAWgB;EACI,aAAA;EACA,YAAA;EACA,qDAAA;AATpB;AAaY;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAXhB;AAagB;EACI,gBAAA;AAXpB;AAgBQ;EACI,WAAA;AAdZ;AAgBY;EACI,uBAAA;AAdhB;AAiBY;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AAfhB;AE5GE;EF5EF;IAyNQ,mBAAA;EA7BN;EAkCU;IACI,gBAAA;IACA,SAAA;IACA,UAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,iBAAA;EAhCd;EAmCkB;IACI,iBAAA;EAjCtB;EAmCsB;IACI,iBAAA;IACA,aAAA;IACA,cAAA;IACA,qBAAA;EAjC1B;EAmC0B;IACI,kBAAA;EAjC9B;AACF;AEtIE;EF5EF;IA4PQ,eAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;IACA,aAAA;IACA,sBAAA;IACA,WAAA;EAtCN;EAwCM;IACI,cAAA;IACA,gBAAA;IACA,YAAA;EAtCV;AACF;AEzKE;EF1DF;IA6QQ,SAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,kBAAA;IACA,eAAA;EAtCN;AACF;;AA4CA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAzCJ;AA2CI;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;AAzCR;AA4CI;EACI,aAAA;AA1CR","sourcesContent":["@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n.chat {\n    border-radius: $border-radius2;\n    padding: 0.375rem;\n    background: $color__primary;\n    width: 100%;\n    font-size: 0.75rem;\n    font-weight: 500;\n    position: relative;\n    flex-grow: 1;\n    .drop-overlay{\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0,0,0,0.2);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 10;\n        i{\n            font-size: 2rem;\n            color:#FFF;\n        }\n    }\n    .chat_exit_button {\n        height: 30px;\n        width: 30px;\n        cursor: pointer;\n        z-index: 2;\n        position:absolute;\n        right: 0px;\n        top: -22px;\n        background: functions.image('chat-close.png') no-repeat center center;\n    }\n\n    .chat_messages {\n        display: flex;\n        flex-direction: column;\n        position: relative;\n        flex: 1;\n        overflow-y: hidden;\n        //height: 20rem;\n        //max-height: 50vh;\n        background: $color__white;\n        border-radius: $border-radius2;\n        height: calc(200px);\n        max-height:calc(50vh - 225px);\n        @include functions.responsiveNewTablet {\n            max-height:calc(50vh - 175px);\n        }\n        ul {\n            list-style: none;\n            margin: 0;\n            padding: 0;\n            overflow-y: auto;\n            display: flex;\n            flex-direction: column;\n            flex-wrap: nowrap;\n\n            .message {\n                clear: both;\n                width: 100%;\n                margin-right: auto;\n                margin-left: 0px;\n                display: flex;\n                flex-direction: row;\n                flex-wrap: nowrap;\n                justify-content: flex-start;\n                padding: 0.25rem 0.25rem;\n\n                &.my-message {\n                    margin-right: 0px;\n                    margin-left: auto;\n                    justify-content: flex-end;\n                }\n\n                .message-content {\n                    color: $color__primary-dark;\n                    background: $color_grey;\n                    border-radius: $border-radius1;\n                    width: 100%;\n                    padding: 0.375rem;\n                    overflow: hidden;\n                    p {\n                        margin: 0;\n                        word-wrap: break-word;\n                    }\n\n                    &.message-media {\n                        border-radius: $border-radius3;\n                        border: 1px solid $color-darkgrey;\n                        width: 70px;\n                        height: 70px;\n                        cursor: pointer;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        text-decoration: none;\n\n                        img {\n                            padding: $marge1;\n                            max-width: 100%\n                        }\n\n                        i {\n                            font-size: 40px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .chat_message_action {\n        display: flex;\n        flex-direction: column;\n        flex-wrap: nowrap;\n        margin-top: 0.375rem;\n        align-items: center;\n        position: relative;\n\n        .chat_message_write {\n            width: 100%;\n            width: calc(100% - 2.25rem);\n            margin-left: auto;\n            margin-right: 0;\n            position: relative;\n            border-radius: 0.875rem;\n            flex-grow: 1;\n            display: flex;\n            height: 2.5rem;\n            overflow: hidden;\n            background: $color__white;\n            display: flex;\n            flex-wrap: nowrap;\n            align-items: center;\n            box-shadow: inset -2px 2px 2px rgba(black, 0.25);\n\n            .chat_message_form_input {\n                background: $color__white;\n                flex: 1 1 auto;\n                border: none;\n                outline: none;\n                resize: none;\n                border-radius: 0px;\n                height: 100%;\n                padding: 0.75rem 0.25rem 0.75rem 0.25rem;\n                color: $color__primary-dark;\n                box-shadow: inset 2px 2px 2px rgba(black, 0.25);\n                border: none;\n\n                &:focus {\n                    outline: none;\n                    border: none;\n                    box-shadow: inset 2px 2px 4px rgba($color__primary, 0.5);\n                }\n            }\n\n            .chat_message_send {\n                display: flex;\n                flex-wrap: nowrap;\n                align-items: center;\n                justify-content: center;\n                margin-left: 0.25rem;\n                margin-right: 0.25rem;\n                width: 1.875rem;\n                height: 1.875rem;\n                font-size: 1.125rem;\n                padding: 0px;\n                border-radius: 50%;\n                flex: 0 0 1.875rem;\n\n                .icon-plane {\n                    margin-left: 2px;\n                }\n            }\n        }\n\n        .btn-upload {\n            width: 100%;\n\n            .progress {\n                margin-bottom: 0.375rem;\n            }\n\n            .btn {\n                display: flex;\n                flex-wrap: nowrap;\n                align-items: center;\n                justify-content: center;\n                width: 1.875rem;\n                height: 1.875rem;\n                font-size: 1.125rem;\n                padding: 0px;\n                border-radius: 50%;\n                position: absolute;\n                bottom: 0.25rem;\n                left: 0px;\n                z-index: 1;\n            }\n        }\n    }\n\n    @media (max-height: 789px) {\n        .chat_messages {\n            //height: 15rem;\n        }\n    }\n\n    @include functions.responsiveTablet {\n        .chat_messages {\n            //height: 15rem;\n        }\n    }\n\n    @include functions.responsiveNewTablet {\n        font-size: 0.625rem;\n\n        .chat_messages {\n            //height: 10rem;\n\n            ul {\n                list-style: none;\n                margin: 0;\n                padding: 0;\n                overflow-y: auto;\n                display: flex;\n                flex-direction: column;\n                flex-wrap: nowrap;\n\n                .message {\n                    .message-content {\n                        padding: 0.375rem;\n\n                        &.message-media {\n                            padding: 0.125rem;\n                            width: 2.5rem;\n                            height: 2.5rem;\n                            border-radius: 0.5rem;\n\n                            i {\n                                font-size: 1.75rem;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    @include functions.responsiveWidthOrHeight($screen-sm - 1, $screen-sm -1) {\n        position: fixed;\n        top: 50px;\n        bottom: 70px;\n        left: 5%;\n        right: 5%;\n        display: flex;\n        flex-direction: column;\n        width: auto;\n\n        .chat_messages {\n            flex: 1 1 auto;\n            max-height: none;\n            height: auto;\n        }\n    }\n\n    @include functions.responsiveSmartphone {\n        top: 75px;\n        left: 0px;\n        right: 0px;\n        bottom: 0px;\n        border-radius: 0px;\n        max-height: 25%;\n        .chat_exit_button {\n            //display: none;\n        }\n    }\n}\n\n#btn-show-messages {\n    text-align: center;\n    position: absolute;\n    bottom: 10px;\n    width: 100%;\n    border: 0;\n    z-index: 2;\n    cursor: pointer;\n\n    .btn {\n        padding: 5px 15px 5px;\n        border-radius: 20px;\n        font-size: 12px;\n    }\n\n    &.hide {\n        display: none\n    }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;","@use './variables' as *;\n\n/// Base path for assets (fonts, images...),\n/// should not include trailing slash\n/// @access public\n/// @type String\n$asset-base-path: '../assets' !default;\n\n/// Asset URL builder\n/// @access private\n/// @param {String} $type - Asset type, matching folder name\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the asset\n@function asset($type, $file, $before: '') {\n  @return url($before + $asset-base-path + '/' + $type + '/' + $file);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function image($file, $before: '') {\n  @return asset('images', $file, $before);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function picto($file, $before: '') {\n  @return asset('images/pictos', $file, $before);\n}\n\n/// Font asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the font\n/// @require {function} asset\n@function font($file, $before: '') {\n  @return asset('fonts', $file, $before);\n}\n\n\n// width < 1200px\n@mixin responsiveTablet {\n  @media (max-width: $screen-xl - 1px) {\n    @content;\n  }\n}\n\n// width < 768px OR height < 576px\n@mixin responsiveMobile {\n  @media (max-width: $screen-md - 1px), (max-height: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n// width < 576px\n@mixin responsiveSmartphone {\n  @media (max-width: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n@mixin responsiveWidth($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n\n@mixin responsiveHeight($height) {\n  @media (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveWidthOrHeight($width, $height) {\n  @media (max-width: $width), (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveNewTablet {\n  @include responsiveWidthOrHeight($screen-lg - 1px, 699px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
